<div class="row mb-3">
  <div (click)="showMe = !showMe" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
    <h3 class="zero-text p-base-med">Kunden werben Kunden</h3>
    <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
  </div>
</div>
<div class="row opacity-container" [class.active]="showMe">
  <self-service-self-service-kwk />
</div>
